<template>
  <div class="settings--content">
    <settings-section
      :title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.TITLE')"
      :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.SUB_TEXT')"
    >
      <div class="row whatsapp-pin-section">
        <div class="medium-8 columns">
          <div class="callout alert whatsapp-pin-callout">
            <strong>{{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.WARNING_TITLE') }}</strong>
            <p>{{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.WARNING_BODY') }}</p>
          </div>
          <label :class="{ error: $v.twoStepPin.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.LABEL') }}
            <input
              v-model.trim="twoStepPin"
              type="text"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.PLACEHOLDER')"
              @blur="$v.twoStepPin.$touch"
            />
            <span v-if="$v.twoStepPin.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.ERROR') }}
            </span>
          </label>
          <p class="whatsapp-pin-hint">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.HINT') }}
          </p>
        </div>
      </div>

      <woot-submit-button
        :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.ONBOARDING')"
        @click="startOnboard"
      />

      <form class="row" @submit.prevent="linkNewNumber">
        <div class="medium-8 columns">
          <label :class="{ error: $v.phoneNumber.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
            <input
              v-model.trim="phoneNumber"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')
              "
              @blur="$v.phoneNumber.$touch"
            />
            <span v-if="$v.phoneNumber.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
            </span>
          </label>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.phoneNumberId.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
            <input
              v-model.trim="phoneNumberId"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER')
              "
              @blur="$v.phoneNumberId.$touch"
            />
            <span v-if="$v.phoneNumberId.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
            </span>
          </label>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.businessAccountId.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.LABEL') }}
            <input
              v-model.trim="businessAccountId"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.PLACEHOLDER')
              "
              @blur="$v.businessAccountId.$touch"
            />
            <span v-if="$v.businessAccountId.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.ERROR') }}
            </span>
          </label>
        </div>

        <div class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.LABEL') }}
            <input
              v-model.trim="apiKey"
              type="password"
              autocomplete="off"
              :placeholder="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.API_KEY_PLACEHOLDER'
                )
              "
            />
          </label>
        </div>

        <div class="medium-12 columns">
          <woot-submit-button
            :loading="uiFlags.isUpdating"
            :button-text="
              $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.BUTTON')
            "
          />
        </div>
      </form>

      <p class="whatsapp-reonboard-hint">
        {{ $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.WEBHOOK_HINT') }}
      </p>
    </settings-section>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { isNumber, isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import SettingsSection from '../../../../../components/SettingsSection';
import { ensureFacebookSdk } from 'dashboard/helper/facebookSdk';

export default {
  components: {
    SettingsSection,
  },
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      twoStepPin: '051993',
      phoneNumber: '',
      apiKey: '',
      phoneNumberId: null,
      businessAccountId: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  watch: {
    inbox() {
      this.setDefaults();
    },
  },
  validations: {
    phoneNumber: { required, isPhoneE164OrEmpty },
    phoneNumberId: { required, isNumber },
    businessAccountId: { required, isNumber },
    twoStepPin: {
      required,
      isSixDigitPin(value) {
        return /^\d{6}$/.test(value || '');
      },
    },
  },
  mounted() {
    this.setDefaults();
    ensureFacebookSdk({
      appId: window.chatwootConfig.wbAppId,
      version: 'v20.0',
    }).catch(() => {});

    this.onEmbeddedSignupMessage = event => {
      if (
        event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com'
      ) {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH') {
            const { phone_number_id, waba_id } = data.data;
            this.phoneNumberId = Number(phone_number_id);
            this.businessAccountId = Number(waba_id);
          }
        }
      } catch {
        console.log('Non JSON Response', event.data);
      }
    };

    window.addEventListener('message', this.onEmbeddedSignupMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onEmbeddedSignupMessage);
  },
  methods: {
    waitForPhoneNumberId(timeoutMs = 15000) {
      if (this.phoneNumberId) {
        return Promise.resolve(this.phoneNumberId);
      }

      return new Promise((resolve, reject) => {
        const startedAt = Date.now();
        const intervalId = setInterval(() => {
          if (this.phoneNumberId) {
            clearInterval(intervalId);
            resolve(this.phoneNumberId);
            return;
          }

          if (Date.now() - startedAt >= timeoutMs) {
            clearInterval(intervalId);
            reject(new Error('phone_id_timeout'));
          }
        }, 100);
      });
    },

    onboardErrorMessage(error) {
      const metaMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message;

      if (metaMessage === 'phone_id_timeout') {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ONBOARD_PHONE_ID_TIMEOUT');
      }

      if (
        typeof metaMessage === 'string' &&
        metaMessage.length &&
        metaMessage !== 'phone_id_timeout'
      ) {
        return metaMessage;
      }

      return this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ONBOARD_ERROR_MESSAGE');
    },

    async completeOnboard(code) {
      try {
        const phoneId = await this.waitForPhoneNumberId();
        const data = await this.$store.dispatch('createOnboard', {
          code,
          phone_id: phoneId,
          pin: this.twoStepPin,
        });

        this.apiKey = data.access_token;
        this.phoneNumber = data.phone_number;
        this.showAlert(
          this.$t(
            'INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.AUTO_FILL_MESSAGE'
          )
        );
      } catch (error) {
        console.error('Error on Request Meta:', error);
        this.showAlert(this.onboardErrorMessage(error));
      }
    },

    async linkNewNumber() {
      this.$v.phoneNumber.$touch();
      this.$v.phoneNumberId.$touch();
      this.$v.businessAccountId.$touch();

      if (
        this.$v.phoneNumber.$invalid ||
        this.$v.phoneNumberId.$invalid ||
        this.$v.businessAccountId.$invalid
      ) {
        return;
      }

      try {
        const providerConfig = {
          phone_number_id: Number(this.phoneNumberId),
          business_account_id: Number(this.businessAccountId),
        };
        if (this.apiKey) {
          providerConfig.api_key = this.apiKey;
        }

        await this.$store.dispatch('inboxes/updateInbox', {
          id: this.inbox.id,
          formData: false,
          channel: {
            phone_number: this.phoneNumber,
            provider_config: providerConfig,
          },
        });
        this.showAlert(
          this.$t(
            'INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.SUCCESS_MESSAGE'
          )
        );
      } catch (error) {
        this.showAlert(
          error.message ||
            this.$t(
              'INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_REONBOARD.ERROR_MESSAGE'
            )
        );
      }
    },

    setDefaults() {
      this.phoneNumber = this.inbox.phone_number || '';
      this.apiKey = '';
      this.phoneNumberId = this.inbox.provider_config?.phone_number_id || null;
      this.businessAccountId =
        this.inbox.provider_config?.business_account_id || null;
    },

    async startOnboard() {
      this.$v.twoStepPin.$touch();
      if (this.$v.twoStepPin.$invalid) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.ERROR'));
        return;
      }

      try {
        const FB = await ensureFacebookSdk({
          appId: window.chatwootConfig.wbAppId,
          version: 'v20.0',
        });

        FB.login(
          response => {
            if (response?.authResponse?.code) {
              this.completeOnboard(response.authResponse.code);
            }
          },
          {
            config_id: window.chatwootConfig.wbConfigId,
            response_type: 'code',
            override_default_response_type: true,
            extras: {
              feature: 'whatsapp_embedded_signup',
              version: 2,
              sessionInfoVersion: 2,
            },
          }
        );
      } catch (error) {
        console.error('Error initializing Facebook SDK for WhatsApp:', error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.whatsapp-pin-section {
  margin-bottom: var(--space-normal);
}

.whatsapp-pin-callout {
  margin-bottom: var(--space-small);
  border-left: 4px solid var(--r-500);
  font-size: var(--font-size-small);

  strong {
    display: block;
    margin-bottom: var(--space-smaller);
    font-size: var(--font-size-default);
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  p {
    margin: 0;
    line-height: 1.45;
  }
}

.whatsapp-pin-hint {
  margin-top: var(--space-smaller);
  color: var(--s-600);
  font-size: var(--font-size-mini);
  line-height: 1.4;
}

.whatsapp-reonboard-hint {
  margin-top: var(--space-normal);
  color: var(--s-600);
  font-size: var(--font-size-mini);
  line-height: 1.4;
}
</style>
